import { Dialog, DialogProps, Typography } from '@material-ui/core'
import { useEffect, useState } from 'react'

import Card from '../../../components/card'
import CheckPassword from './check-password'
import NewPassword from './new-password'
import { useStyles } from './styles'

interface ChangePasswordProps extends DialogProps {
  onClose: () => void
}

export default function ChangePassword(props: ChangePasswordProps) {
  const classes = useStyles()
  const [isValidCurrentPassword, setIsValidCurrentPassword] = useState(false)

  useEffect(() => {
    if (!props.open) setTimeout(() => setIsValidCurrentPassword(false), 300)
  }, [props.open])

  return (
    <Dialog {...props}>
      <Card className={classes.card} contentClassName={classes.cardContent}>
        <Typography variant='h2' className={classes.title}>
          Mudar senha
        </Typography>

        {isValidCurrentPassword ? (
          <NewPassword handleClose={props.onClose} />
        ) : (
          <CheckPassword
            handleClose={props.onClose}
            checkPasswordAsTrue={() => setIsValidCurrentPassword(true)}
          />
        )}
      </Card>
    </Dialog>
  )
}
